import React from 'react';
import { Form, Card, Button, Spinner } from 'react-bootstrap';
import { useUploadFile } from '../../../../../api/fileUpload/fileUpload.hooks';

const NavbarEditor = ({ navbar, onChange }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleLogoChange = (index, value) => {
    const newLogos = [...navbar.logos];
    newLogos[index] = value;
    onChange({ ...navbar, logos: newLogos });
  };

  const handleLogoUpload = async (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const result = await upload(file);
      handleLogoChange(index, result.url);
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  const removeLogo = (index) => {
    const newLogos = navbar.logos.filter((_, i) => i !== index);
    onChange({ ...navbar, logos: newLogos });
  };

  const addLogo = () => {
    if (navbar.logos.length >= 3) return; // Max 3 logos
    onChange({ ...navbar, logos: [...navbar.logos, ''] });
  };

  const handleMenuChange = (index, field, value) => {
    const newMenus = [...navbar.menus];
    newMenus[index] = { ...newMenus[index], [field]: value };
    onChange({ ...navbar, menus: newMenus });
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">Navbar Configuration</h5>
      </Card.Header>
      <Card.Body>
        {/* Logos Section */}
        <div className="mb-4">
          <h6 className="mb-3">Logos</h6>
          
          <div className="row">
            {navbar.logos.map((logo, index) => {
              const logoLabel = index === 0 ? 'Main Logo' : `Side Logo ${index}`;
              
              return (
                <div key={index} className="col-md-4 mb-3">
                  <div className="p-3 border rounded h-100">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <strong>{logoLabel}</strong>
                      {navbar.logos.length > 1 && (
                        <Button variant="outline-danger" size="sm" onClick={() => removeLogo(index)}>
                          <i className="fa fa-trash"></i>
                        </Button>
                      )}
                    </div>
                    
                    <div>
                      {logo ? (
                        <div className="position-relative d-inline-block">
                          <img
                            src={logo}
                            alt={logoLabel}
                            style={{ width: '100%', maxWidth: '150px', height: '80px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #dee2e6' }}
                          />
                          <Button
                            variant="danger"
                            size="sm"
                            className="position-absolute top-0 end-0"
                            style={{ transform: 'translate(50%, -50%)' }}
                            onClick={() => handleLogoChange(index, '')}
                          >
                            <i className="fa fa-times"></i>
                          </Button>
                        </div>
                      ) : (
                        <Button
                          variant="outline-primary"
                          as="label"
                          disabled={isUploading}
                        >
                          {isUploading ? <Spinner animation="border" size="sm" /> : <><i className="fa fa-upload me-1"></i> Upload</>}
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(e) => handleLogoUpload(index, e)}
                          />
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          
          {navbar.logos.length < 3 && (
            <Button variant="outline-primary mt-3" size="sm" onClick={addLogo}>
              <i className="fa fa-plus me-1"></i> Add {navbar.logos.length === 0 ? 'Main Logo' : 'Side Logo'}
            </Button>
          )}
        </div>

        {/* Menus Section */}
        <div>
          <h6 className="mb-3">Menu Item</h6>
          {navbar.menus.length > 0 && (
            <div className="p-3 border rounded">
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-2">
                    <Form.Label>Label</Form.Label>
                    <Form.Control
                      type="text"
                      value={navbar.menus[0].label}
                      onChange={(e) => handleMenuChange(0, 'label', e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-2">
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      value={navbar.menus[0].link}
                      onChange={(e) => handleMenuChange(0, 'link', e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default NavbarEditor;
